import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { formatDate } from "helpers/DateHelper";
import NoTableData from "components/NoTableData";

const DeviceRow = ({ tableData, hideVendors }) => {
  if (tableData.length) {
    return tableData.map((row, i) => {
      const { id, modelnumber, name, display, completedat } = row;
      return (
        <tr key={i}>
          {hideVendors ? null : <td>{name}</td>}
          <td>
            <Link to={`/devices/${id}`}>{modelnumber}</Link>
          </td>
          <td>{display}</td>
          <td>{formatDate(completedat)}</td>
        </tr>
      );
    });
  }

  return <NoTableData />;
};

DeviceRow.propTypes = {
  tableData: PropTypes.array
};

export default DeviceRow;



// WEBPACK FOOTER //
// ./src/containers/Devices/DeviceRow.js